import { cn } from "@/lib/cn";

type BrandMarkProps = {
  className?: string;
  /** Show wordmark beside the icon */
  withWordmark?: boolean;
  /** Light text for dark / gradient backgrounds */
  inverted?: boolean;
};

export function BrandMark({
  className,
  withWordmark = false,
  inverted = false,
}: BrandMarkProps) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <img
        src="/favicon.png"
        alt="Fincobox"
        width={32}
        height={32}
        className="size-8 shrink-0 rounded-full bg-white shadow-sm ring-1 ring-black/5"
      />
      {withWordmark ? (
        <span className="leading-tight">
          <span
            className={cn(
              "block text-sm font-semibold",
              inverted ? "text-white" : "text-ink",
            )}
          >
            Fincobox
          </span>
          <span
            className={cn(
              "block text-[11px] uppercase tracking-[0.14em]",
              inverted ? "text-white/70" : "text-muted",
            )}
          >
            Partner
          </span>
        </span>
      ) : null}
    </span>
  );
}
